module.exports = __webpack_public_path__ + "img/importFileIcon.5926ce38.svg";